import React from "react";
import { Subscribe } from "unstated";
import PlayerContainer from "../state";

export class RagaSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = { expanded: false, selectedRaga: null };
        this.getDropDownStyle = this.getDropDownStyle.bind(this);
        this.toggleExpanded = this.toggleExpanded.bind(this);
        // this.setRaga = this.setRaga.bind(this);
    }

    getDropDownStyle() {
        if (!this.state.expanded) return "dropdown raga-selector";
        else return "dropdown raga-selector is-active";
    }
    toggleExpanded() {
        this.setState({ expanded: !this.state.expanded });
    }

    
    // setRaga(raga) {
    //   this.setState({ selectedRaga: raga, expanded: false });
    // }

    render() {
        return (
            <Subscribe to={[PlayerContainer]}>
                {playerContainer => (
                    <div className={this.getDropDownStyle()}>
                        <div className="dropdown-trigger" onClick={this.toggleExpanded}>
                            <button className="button" aria-haspopup="true" aria-controls="dropdown">
                                <span className="dd-text">
                                    {this.state.selectedRaga === null ? "Choose any ragam" : this.state.selectedRaga.name}
                                </span>
                                <span className="icon is-small">
                                    <i className="fas fa-angle-down" aria-hidden="false"></i>
                                </span>
                            </button>
                        </div>
                        <div className="dropdown-menu" role="menu">
                            <div className="dropdown-content">
                                {this.props.ragas.map((raga) => (
                                    <a href="#" className="dropdown-item" onClick={() => {
                                        playerContainer.setRaga(raga);
                                        this.toggleExpanded();
                                        }}>
                                        {raga.name}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </Subscribe>
        );
    }
}
